import React, {
  useMemo,
  useState,
  useCallback,
  useRef
} from 'react';
import { Button } from 'devextreme-react';
// import Accordion from 'devextreme-react/accordion';
import Drawer from 'devextreme-react/drawer';
import Form, {
  SimpleItem,
  RequiredRule,
  GroupItem,
  ButtonItem
} from 'devextreme-react/form';
import style from './addedstocks.module.scss';

const cursor = {};

// eslint-disable-next-line no-extend-native,func-names
Array.prototype.sum = function (prop) {
  let total = 0;
  // eslint-disable-next-line no-plusplus
  for (let i = 0, len = this.length; i < len; i++) {
    total += this[i][prop];
  }
  return total;
};

const AddedStocks = ({
  metricReducer: { listAddedStocks },
  metricAddedStocks
}) => {
  const form = useRef(null);
  const [visibleDrawer, setVisibleDrawer] = useState(true);
  const [stocksData, setStocksData] = useState([]);
  const [stocksType, setStocksType] = useState([]);

  /** Действие на сабмит */
  const formOnSubmit = useCallback((e) => {
    e.preventDefault();
    metricAddedStocks({
      dateFrom: cursor.dateFrom,
      dateTo: cursor.dateTo
    });
  }, [metricAddedStocks]);

  /** Рендер панели фильтров */
  const RenderLeftDrawer = useMemo(() => () => (
    <div className={style.form}>
      <form method="POST"
            onSubmit={formOnSubmit}
      >
        <Form labelLocation="top"
              width="100%"
              readOnly={false}
              showColonAfterLabel
              showValidationSummary={false}
              formData={cursor}
              ref={form}
        >
          <GroupItem>
            <SimpleItem dataField="dateFrom"
                        editorType="dxDateBox"
                        label={{ text: 'Дата с' }}
                        editorOptions={{
                          stylingMode: 'filled',
                          dateSerializationFormat: 'yyyy-MM-dd'
                        }}
            >
              <RequiredRule message="Выберите значение" />
            </SimpleItem>
            <SimpleItem dataField="dateTo"
                        editorType="dxDateBox"
                        label={{ text: 'Дата по' }}
                        editorOptions={{
                          stylingMode: 'filled',
                          dateSerializationFormat: 'yyyy-MM-dd'
                        }}
            >
              <RequiredRule message="Выберите значение" />
            </SimpleItem>
            <ButtonItem horizontalAlignment="right"
                        buttonOptions={{
                          text: 'Выбрать',
                          type: 'default',
                          useSubmitBehavior: true
                        }}
            />
          </GroupItem>
        </Form>
      </form>
    </div>
  ), [
    formOnSubmit
  ]);

  /** Клик на bar */
  const onSpanClick = useCallback((stockTypeId) => {
    setStocksData(listAddedStocks.filter((stock) => ((stockTypeId < 100)
      ? stock.plantTypeId === stockTypeId
      : stock.plantTypeId >= stockTypeId)));
    setStocksType(stockTypeId);
  }, [setStocksData, listAddedStocks]);

  /** Рендер основного списка метрик по складам */
  const RenderMain = useCallback(
    (x) => (
      <>
        {/* <div> */}
        {/*  <span> */}
        {/*    Всего подключённых складов:&nbsp; */}
        {/*    {listAddedStocks.length} */}
        {/*  </span> */}
        {/* </div> */}
        {/* <Accordion */}
        {/*  id="accordion-container" */}
        {/*  dataSource={listAddedStocks} */}
        {/*  itemTitleRender={(item) => item && `${item.plantDescription}`} */}
        {/* /> */}
        <div className={style.containing}>
          <div className={style.line}>
            <span>
              Всего подключённых складов:&nbsp;
              {listAddedStocks.length}
            </span>
          </div>
          <div className={style.line}>
            <span>
              Всего складов с запасами:&nbsp;
              {listAddedStocks
                .filter((stock) => stock.weightIncoming > 0 || stock.weightShipping > 0)
                .length}
            &nbsp;(общий объём запасов&nbsp;
              {listAddedStocks.sum('weightShipping') / 1000}
            &nbsp;т. в наличии,&nbsp;
              {listAddedStocks.sum('weightIncoming') / 1000}
            &nbsp;т. в пути)
            </span>
          </div>
          <div className={style.line}>
            <span className={style.stockName}>
              Консигнационных складов:&nbsp;
              {listAddedStocks
                .filter((stock) => stock.plantTypeId === 1)
                .length}
            </span>
            {/* eslint-disable-next-line max-len */}
            {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions,jsx-a11y/click-events-have-key-events */}
            <span className={style.link}
                  onClick={() => (onSpanClick(1))}>
              из них с запасами:&nbsp;
              {listAddedStocks
                .filter((stock) => stock.plantTypeId === 1)
                .filter((stock) => stock.weightIncoming > 0 || stock.weightShipping > 0)
                .length}
            &nbsp;(общий объём запасов&nbsp;
              {listAddedStocks
                .filter((stock) => stock.plantTypeId === 1)
                .sum('weightShipping') / 1000}
            &nbsp;т. в наличии,&nbsp;
              {listAddedStocks
                .filter((stock) => stock.plantTypeId === 1)
                .sum('weightIncoming') / 1000}
            &nbsp;т. в пути)
            </span>
          </div>
          <div className={style.line}>
            <span className={style.stockName}>
              Складов переработчиков:&nbsp;
              {listAddedStocks
                .filter((stock) => stock.plantTypeId === 2)
                .length}
            </span>
            {/* eslint-disable-next-line max-len */}
            {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions,jsx-a11y/click-events-have-key-events */}
            <span className={style.link}
                  onClick={() => (onSpanClick(2))}>
              из них с запасами:&nbsp;
              {listAddedStocks
                .filter((stock) => stock.plantTypeId === 2)
                .filter((stock) => stock.weightIncoming > 0 || stock.weightShipping > 0)
                .length}
            &nbsp;(общий объём запасов&nbsp;
              {listAddedStocks
                .filter((stock) => stock.plantTypeId === 2)
                .sum('weightShipping') / 1000}
            &nbsp;т. в наличии,&nbsp;
              {listAddedStocks
                .filter((stock) => stock.plantTypeId === 2)
                .sum('weightIncoming') / 1000}
            &nbsp;т. в пути)
            </span>
          </div>
          <div className={style.line}>
            <span className={style.stockName}>
              Складов поточной модели:&nbsp;
              {listAddedStocks
                .filter((stock) => stock.plantTypeId > 100)
                .length}
            </span>
            {/* eslint-disable-next-line max-len */}
            {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions,jsx-a11y/click-events-have-key-events */}
            <span className={style.link}
                  onClick={() => (onSpanClick(100))}>
              из них с запасами:&nbsp;
              {listAddedStocks
                .filter((stock) => stock.plantTypeId > 100)
                .filter((stock) => stock.weightIncoming > 0 || stock.weightShipping > 0)
                .length}
            &nbsp;(общий объём запасов&nbsp;
              {listAddedStocks
                .filter((stock) => stock.plantTypeId > 100)
                .sum('weightShipping') / 1000}
            &nbsp;т. в наличии,&nbsp;
              {listAddedStocks
                .filter((stock) => stock.plantTypeId > 100)
                .sum('weightIncoming') / 1000}
            &nbsp;т. в пути)
            </span>
          </div>
          <div className={style.line}>
            <span className={style.stockName}>
              Складов экспедиторов:&nbsp;
              {listAddedStocks
                .filter((stock) => stock.plantTypeId === 0)
                .length}
            </span>
            {/* eslint-disable-next-line max-len */}
            {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions,jsx-a11y/click-events-have-key-events */}
            <span className={style.link}
                  onClick={() => (onSpanClick(0))}>
              из них с запасами:&nbsp;
              {listAddedStocks
                .filter((stock) => stock.plantTypeId === 0)
                .filter((stock) => stock.weightIncoming > 0 || stock.weightShipping > 0)
                .length}
            &nbsp;(общий объём запасов&nbsp;
              {listAddedStocks
                .filter((stock) => stock.plantTypeId === 0)
                .sum('weightShipping') / 1000}
            &nbsp;т. в наличии,&nbsp;
              {listAddedStocks
                .filter((stock) => stock.plantTypeId === 0)
                .sum('weightIncoming') / 1000}
            &nbsp;т. в пути)
            </span>
          </div>
        </div>
      </>
    ), [listAddedStocks, onSpanClick]
  );

  /** Рендер основного списка метрик по складам */
  const RenderDetail = useCallback(
    (x) => (stocksData.length > 0
      && stocksData.map((item) => (
        <div className={style.line} key={item.plantDescription}>
          <span>
            {item.plantDescription}
            &nbsp;
            -&nbsp;
            {item.weightShipping / 1000}
            &nbsp;т. в наличии,&nbsp;
            {item.weightIncoming / 1000}
            &nbsp;т. в пути
          </span>
        </div>
      ))
    ), [stocksData]
  );

  /** Рисование формы метрик с содержимым */
  const RenderContend = useCallback(() => {
    if (listAddedStocks === null) {
      return (
        <div className={style.text}>Выберите данные для построения метрики</div>
      );
    }
    if (listAddedStocks.length) {
      return (
        <>
          <RenderMain />
          {stocksType === 0 && (
            <span className={style.line}>Всего складов экспедиторов</span>
          )}
          {stocksType === 1 && (
            <span className={style.line}>Всего консигнационных складов</span>
          )}
          {stocksType === 2 && (
            <span className={style.line}>Всего складов переработчиков</span>
          )}
          {stocksType === 3 && (
            <span className={style.line}>Всего складов поточной модели</span>
          )}
          <div className={style.containing}>
            <RenderDetail />
          </div>
        </>
      );
    }
    return (
      <div className={style.text}>Нет данных для отображения</div>
    );
  }, [listAddedStocks, stocksType]);

  return (
    <div className={style.container}>
      <Drawer opened={visibleDrawer}
              elementAttr={{ class: style.drawer }}
              component={RenderLeftDrawer}
              position="left"
              revealMode="slide"
              openedStateMode="shrink"
      >
        <div className={style.main}>
          <Button elementAttr={{ class: style.buttonDrawer }}
                  stylingMode={'text'}
                  icon={!visibleDrawer ? 'filter' : 'arrowleft'}
                  type="normal"
                  onClick={() => setVisibleDrawer((current) => !current)}
          />
          <RenderContend />
        </div>
      </Drawer>
    </div>
  );
};

export default AddedStocks;
